import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { trackFunnelEvent } from '../../utils/analytics';

interface InterpretationCardProps {
  title: string;
  subtitle: string;
  content: string;
  unlocked: boolean;
  onUpgradeClick?: () => void;
}

export function InterpretationCard({
  title,
  subtitle,
  content,
  unlocked,
  onUpgradeClick,
}: InterpretationCardProps) {
  const navigate = useNavigate();

  function handleUnlock() {
    onUpgradeClick?.();
    trackFunnelEvent('paywall_hit', { source: 'interpretation_card', planet: title });
    navigate('/pricing');
  }

  return (
    <div className="card" style={{ padding: '1rem', position: 'relative', overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
        <div>
          <p style={{ fontWeight: 600, fontSize: 'var(--text-label)', color: 'var(--text-primary)', margin: 0 }}>{title}</p>
          <p style={{ fontSize: 'var(--text-caption)', color: 'var(--petrol)', margin: '0.1rem 0 0', fontWeight: 500 }}>{subtitle}</p>
        </div>
        {!unlocked && <Lock size={15} style={{ color: 'var(--text-muted)', flexShrink: 0, marginTop: '2px' }} />}
      </div>

      <div style={{ position: 'relative' }}>
        <p style={{
          fontSize: 'var(--text-label)',
          color: 'var(--text-secondary)',
          lineHeight: 1.65,
          margin: 0,
          filter: unlocked ? 'none' : 'blur(5px)',
          userSelect: unlocked ? 'auto' : 'none',
        }}>
          {content}
        </p>

        {!unlocked && (
          <div style={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'rgba(10,6,20,0.55)',
            backdropFilter: 'blur(2px)',
            borderRadius: 'var(--radius-sm)',
          }}>
            <button
              onClick={handleUnlock}
              className="btn btn-primary btn-sm"
              style={{ display: 'flex', alignItems: 'center', gap: '0.35rem', fontSize: 'var(--text-caption)' }}
            >
              <Lock size={13} /> Desbloquear
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
